module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai29-8a26a7da9b0ef326a0527a0826e26006.jpg";